import {
  DialogCompositeMui as DialogComposite,
  FormFieldsProvider,
  useFormFieldsContext,
} from '@spotify/confidence-core-react';

import { AboutFormFields } from '../forms';
import { MetricFormValues } from '../types';

type AboutValues = Pick<
  MetricFormValues,
  'displayName' | 'description' | 'owner'
>;

type EditAboutDialogProps = {
  open: boolean;
  value: AboutValues;
  onClose: () => void;
  onSubmit: (value: AboutValues) => void;
};

const EditAboutDialogContent = ({
  onClose,
  onSubmit,
}: Omit<EditAboutDialogProps, 'open' | 'value'>) => {
  const { values } = useFormFieldsContext<AboutValues>();

  const handleSubmit = () => {
    onSubmit({
      displayName: values.displayName,
      description: values.description,
      owner: values.owner,
    });
    onClose();
  };

  const isValid = Boolean(values.displayName && values.owner);

  return (
    <DialogComposite.Content
      data-track-scope="dialog.edit-about"
      data-track-id="dialog.edit-about"
      data-track-impression
    >
      <DialogComposite.Header>
        <DialogComposite.Title>About</DialogComposite.Title>
        <DialogComposite.Subtitle>
          Set a name and description.
        </DialogComposite.Subtitle>
        <DialogComposite.CloseButton />
      </DialogComposite.Header>
      <DialogComposite.Body>
        <AboutFormFields />
      </DialogComposite.Body>
      <DialogComposite.Actions>
        <DialogComposite.Actions.Cancel onClick={onClose}>
          Cancel
        </DialogComposite.Actions.Cancel>
        <DialogComposite.Actions.Primary
          onClick={handleSubmit}
          disabled={!isValid}
        >
          Save
        </DialogComposite.Actions.Primary>
      </DialogComposite.Actions>
    </DialogComposite.Content>
  );
};

export const EditAboutDialog = ({
  open,
  value,
  onClose,
  onSubmit,
}: EditAboutDialogProps) => {
  return (
    <DialogComposite.Root open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {open && (
        <FormFieldsProvider initialValues={value}>
          <EditAboutDialogContent onClose={onClose} onSubmit={onSubmit} />
        </FormFieldsProvider>
      )}
    </DialogComposite.Root>
  );
};
